module.exports = __webpack_public_path__ + "static/feature_information-e2c77bce6cd6483e453fb77306fd6e32.png";